import PropTypes from 'prop-types';

import {SidePanel} from 'front-onceforall-core';

import {USER_REQUEST_TYPES} from '../../../utils/constant';

import Contact from '../../Contact';

function ContactSidePanel(props) {
  let triggerClosePanel = () => {};

  if (!props.isOpen) {
    return null;
  }

  return (
    <SidePanel
      onClose={props.onClose}
      big
      setCloseTrigger={closeFunction => {
        triggerClosePanel = closeFunction;
      }}
    >
      <Contact
        selectedRequestType={USER_REQUEST_TYPES.MY_PROJECTS}
        onClose={() => triggerClosePanel()}
      />
    </SidePanel>
  );
}

ContactSidePanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ContactSidePanel;
